const Facebook = () => {
  return (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_147_689)">
        <circle cx="41.5" cy="39.5" r="34.5" fill="white" />
      </g>
      <path
        d="M43.5001 61.1044H37.5001C36.9478 61.1044 36.5001 60.6566 36.5001 60.1044V42.1044C36.5001 41.5521 36.0524 41.1044 35.5001 41.1044H30C29.4477 41.1044 29 40.6566 29 40.1044V35.1044C29 34.5521 29.4477 34.1044 30 34.1044H35.5001C36.0524 34.1044 36.4989 33.6587 36.4853 33.1066C36.3835 28.9627 35.9298 22.4089 41.0001 20.1043C44.977 18.2966 48.845 19.0759 50.9058 19.8578C51.2724 19.9969 51.5001 20.3561 51.5001 20.7483V26.1044C51.5001 26.6566 51.0523 27.1044 50.5001 27.1044H45.5001C44.9478 27.1044 44.5001 27.5521 44.5001 28.1044V33.1044C44.5001 33.6566 44.9478 34.1044 45.5001 34.1044H50.5001C51.0523 34.1044 51.5001 34.5521 51.5001 35.1044V40.1044C51.5001 40.6566 51.0523 41.1044 50.5001 41.1044H45.5001C44.9478 41.1044 44.5001 41.5521 44.5001 42.1044V60.1044C44.5001 60.6566 44.0524 61.1044 43.5001 61.1044Z"
        stroke="black"
        strokeWidth="3"
      />
      <defs>
        <filter
          id="filter0_d_147_689"
          x="0"
          y="0"
          width="83"
          height="83"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_147_689"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0 0.291667 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_147_689"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_147_689"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export default Facebook;
